/* Reveal-on-scroll for [data-reveal] elements.
   Safety: anything already in the viewport (e.g. after an anchor jump) reveals
   immediately, and a final pass on load guarantees nothing stays hidden. */
(function () {
  var els = Array.prototype.slice.call(document.querySelectorAll('[data-reveal]'));
  if (!els.length) return;

  function show(el) { el.classList.add('is-visible'); }

  function revealInView() {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    els.forEach(function (el) {
      if (el.classList.contains('is-visible')) return;
      var r = el.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) show(el);
    });
  }

  if (!('IntersectionObserver' in window)) {
    els.forEach(show);
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        show(entry.target);
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  els.forEach(function (el) { io.observe(el); });

  revealInView();
  window.addEventListener('load', revealInView);
  window.addEventListener('hashchange', function () { setTimeout(revealInView, 60); });
})();
